/**
 * training-wizard-menu.js
 */

import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Types } from 'utils/constants';
import { makeLocation } from 'utils/routing';
import TrainingMenu from './training-menu';
import ExerciseMenuItem from '../exercise/menu-item';
import { shouldRenderMobileLayout } from 'utils/app-context';


export default function TrainingWizardMenu(props) {
  const {
    basePath,
  } = props;
  let params = useParams();
  let location = useLocation();
  let {step, type, id} = params;
  step = parseInt(step);
  id = parseInt(id);
  const [locationGetter, setLocationGetter] = React.useState();
  const [extraExercises, setExtraExercises] = React.useState();
  const [isActiveGetter, setIsActiveGetter] = React.useState();


  React.useEffect(() => {

    // STEP 1 - create event
    if (step === 1) {
      setLocationGetter();
      setIsActiveGetter();
      setExtraExercises();
    }

    // STEP 2 - create exercise
    else if (step === 2) {
      setLocationGetter(() => (itemType, itemId) => {
        return itemType === Types.Record.EVENT
          ? makeLocation(
              basePath,
              'training',
              'wizardEditEvent',
              {eventId: itemId},
              location
            )
          : null;
      });
      setIsActiveGetter();
      setExtraExercises(
        <ExerciseMenuItem
          id={0}
          to={makeLocation(
            basePath,
            'training',
            'wizardAddExercise',
            {eventId: id},
            location
          )}
          active={true}
        />
      );
    }

    // STEP 3 - create answer
    else if (step === 3) {
      setLocationGetter(() => (itemType, itemId) => {
        return itemType === Types.Record.EVENT
          ? makeLocation(
              basePath,
              'training',
              'wizardEditEvent',
              {eventId: itemId},
              location
            )
          : makeLocation(
              basePath,
              'training',
              'wizardEditExercise',
              {exerciseId: itemId},
              location
            );
      });
      setIsActiveGetter(() => (itemType, itemId, locationObj) => {
        return itemType === Types.Record.EXERCISE
          ? locationObj.pathname.includes(`/${type}/${id}`)
          : null;
      });
      setExtraExercises();
    }

    // STEP 4 - view exercise or index
    else if (step === 4) {
      setLocationGetter();
      setIsActiveGetter(() => (itemType, itemId, locationObj) => {
        if (itemType === Types.Record.EVENT) {
          return !shouldRenderMobileLayout() && locationObj.pathname.includes(`/${type}/${id}`);
        } else if (itemType === Types.Record.EXERCISE) {
          return locationObj.pathname.includes(`/${type}/${id}`);
        }
      });
      setExtraExercises();
    }

  }, [step, type, id, basePath, location]);


  return (
    <>
      <TrainingMenu
        {...props}
        type={type}
        locationOverride={locationGetter}
        isActiveOverride={isActiveGetter}
        extraExercises={extraExercises}
        showAddExercise={step === 4}
      />
    </>
  );
}